import React, { useEffect, useState, useCallback } from "react";
import { Grid, Box, Button, CircularProgress } from "@material-ui/core";
import clsx from "clsx";
import moment from "moment";
import QRCode from "react-qr-code";
import { useStyles } from "./TicketlessValetRequest.styles";
import TicketlessValetService from "../../services/TicketlessValetService";
import GenericError from "../../components/MobilePayment/GenericError";
import apiClient from "../../auth/apiClient";

const ticketlessValetService = new TicketlessValetService(apiClient);

const formatDt = (dt) => (dt ? moment(dt).format("MM/DD/YY, h:mm A") : "");

const TicketlessValetRequest = ({ credentialId }) => {
  const classes = useStyles();
  const [details, setDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);

  const getRequestDetails = useCallback(async () => {
    try {
      const response = await ticketlessValetService.getTicketDetails(credentialId);
      const data = response.data;
      if (data && data.ticketNumber) {
        setDetails(data);
      } else {
        setErrorMessage(["Invalid Ticket"]);
      }
    } catch (error) {
      if (error?.response?.status === 404) {
        setErrorMessage(["Invalid Ticket"]);
      } else {
        setErrorMessage(["Error retrieving valet request details."]);
      }
    } finally {
      setIsLoading(false);
    }
  }, [credentialId]);

  useEffect(() => {
    if (credentialId) {
      getRequestDetails();
    }
  }, [credentialId, getRequestDetails]);

  if (isLoading) {
    return <CircularProgress size={60} className={classes.circularProgress} />;
  }

  if (errorMessage) {
    return <GenericError message={errorMessage}></GenericError>;
  }

  if (!details) {
    return <GenericError message={["Please try again"]}></GenericError>;
  }

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      spacing={2}
      className={classes.detailsContainer}
    >
      <Grid item xs={12} className={classes.valetAreaRow}>
        <Box className={classes.valetAreaValue}>{details.valetAreaName}</Box>
      </Grid>

      <Grid item xs={12} className={classes.fieldRow}>
        <Box className={classes.fieldLabel}>Ticket Number</Box>
        <Box className={classes.fieldValue}>{details.ticketNumber}</Box>
      </Grid>

      <Grid item>
        <div className={clsx(classes.qrcode, "ticket-number")}>
          <QRCode value={String(details.ticketNumber)} size={200} />
        </div>
      </Grid>

      <Grid item xs={12} className={classes.fieldRow}>
        <Box className={classes.fieldLabel}>Arrival Time</Box>
        <Box className={classes.fieldValue}>{formatDt(details.arrivalDate)}</Box>
      </Grid>

      <Grid item xs={12} className={classes.buttonContainer}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          className={classes.requestButton}
        >
          Request My Car
        </Button>
      </Grid>
    </Grid>
  );
};

export default TicketlessValetRequest;
